import {APIImobsaleUrl, APICadimo5Url, APIEmailUrl} from "../../../config/constants";
export const API_VENDAS = `${APIImobsaleUrl}`;
export const API_CADIMO5 = `${APICadimo5Url}`;
export const API_EMAIL = `${APIEmailUrl}`;